import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { CircleCloseIcon } from 'Components/CircleCloseIcon';
import { useEffect } from 'react';
import { isSafari } from 'react-device-detect';

interface IProps {
  onClose: () => void;
  requestNumber?: string;
  title?: string;
}
export const DialogTitleContent = (props: IProps) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);
  useEffect(() => {
    document.getElementById('dialog-title')?.focus();
  }, []);
  return (
    <Grid
      container
      direction={'row'}
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
        height: '100%',
      }}
    >
      <Typography variant='h2' component='h2' tabIndex={0} id='dialog-title'>
        {props.title || dictionary.orderSummaryDialog.title}
      </Typography>
      {isDesktop && (
        <CircleCloseIcon
          size='large'
          alt={dictionary.orderSummaryDialog.closeDialog}
          onClick={props.onClose}
          sx={{
            cursor: 'pointer',
            alignSelf: isDesktop ? '' : 'flex-start',
            top: !isDesktop && isSafari ? '30px' : '',
            width: '40px',
            height: '40px',
          }}
        />
      )}
    </Grid>
  );
};
